import {SegmentFilterController} from 'common/charts/contexts/segment-filter-controller';
import {contextify} from 'common/util/react';

const context = contextify<SegmentFilterController>();

export const SegmentFilterControllerProvider = context.Provider;
export const SegmentFilterControllerConsumer = context.Consumer;
export const useSegmentFilterController = context.hook;
